import React, { useRef } from 'react';
import { Provider } from 'react-redux';
import { store } from "../store";
import { CacheProvider } from "@emotion/react";
import { Box, ChakraProvider } from "@chakra-ui/react";
import { theme } from "../theme";
import createCache from "@emotion/cache";
import { createRoot } from "react-dom/client";
import { Form } from "./Form";
const Wrapper = (props) => {
    const ref = useRef(null);
    return (React.createElement(Provider, { store: store },
        React.createElement(CacheProvider, { value: props.cache },
            React.createElement(ChakraProvider, { theme: theme, toastOptions: { portalProps: { containerRef: ref } } },
                React.createElement(Form, { formId: props.formId }),
                React.createElement(Box, { ref: ref })))));
};
class ReaFormWebComponent extends HTMLElement {
    constructor() {
        super();
        this.root = null;
        this.mount();
    }
    getFormId() {
        const attr = this.getAttribute("form-id");
        if (attr == null || attr === "")
            return null;
        const parsed = parseInt(attr, 10);
        return isNaN(parsed) ? null : parsed;
    }
    mount() {
        const formId = this.getFormId();
        const shadowRoot = this.attachShadow({ mode: "open" });
        const container = document.createElement("div");
        shadowRoot.appendChild(container);
        const cache = createCache({
            container: shadowRoot,
            key: "c"
        });
        this.root = createRoot(container);
        this.root.render((React.createElement(React.Fragment, null, formId != null ? React.createElement(Wrapper, { formId: formId, cache: cache }) : null)));
    }
}
if (!customElements.get('rea-form')) {
    customElements.define('rea-form', ReaFormWebComponent);
}
